<template>
  <LoginAll v-if="loginStatus === 1 && !IsPC" />
  <LoginSimplified v-else-if="loginStatus === 2 && !IsPC" />
  <LoginPC v-else />
</template>

<script>
import { getArgs, getCookie, isWeiXin, isPC } from '@/assets/js/common'
import LoginAll from './components/LoginAll.vue'
import LoginSimplified from './components/LoginSimplified.vue'
import LoginPC from './components/LoginPC.vue'
export default {
  name: 'app',
  components: {
    LoginAll,
    LoginSimplified,
    LoginPC
  },
  data() {
    return {
      loginStatus: 2 // 1 是全登录模式 2 是滇教云登录模式
    }
  },
  created() {
    const params = getArgs()
    if (params.loginStatus) {
      console.log('dfaafdasfasd', params.loginStatus)
      this.loginStatus = Number(params.loginStatus)
    }
    if (params.code) {
      // 根据code获取open_id
      this.getTokenByWeChatCode(params.code)
    }
    this.isWeiXin = isWeiXin()
    window.addEventListener('popstate', () => {
      history.pushState(null, null, document.URL)
    }, false)
    if (getCookie('token')) {
      if (params.goFrom) {
        location.replace(params.goFrom)
      } else {
        location.replace('./EnglishHome.html')
      }
    }
  },
  mounted() {
  },
  computed: {
    IsPC() {
      return isPC()
    }
  },
  watch: {
    /**
     * 监听密码
     */
    'formData.password'(val) {
      if (!/^[A-Za-z0-9]+$/.test(val)) {
        this.formData.password = val.substring(0, val.length - 1)
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.login {
  padding-bottom: 60px;

  /deep/ .van-popover__wrapper {
    height: 16px;
  }

  /deep/ .van-popover__action {
    width: auto;
    height: auto;
    padding: 5px 16px;
  }
  .content {
    .nav {
      margin-bottom: 20px;
      padding: 0 80px;

      &-item {
        position: relative;
        width: 850px;
        height: 40px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        cursor: pointer;

        &.active {
          font-weight: 500;
          color: #46d584;
        }

        .line {
          position: absolute;
          bottom: 0;
          width: 19px;
          height: 4px;
          background: #46d584;
          border-radius: 2px;
        }
      }
    }

    .input-item {
      margin: 0 40px 14px 40px;

      &.top {
        margin-top: -14px;
      }

      /deep/ .van-field {
        padding: 0;
        width: 295px;
        height: 48px;
        background: #f8f8f8;
        border-radius: 24px;
        font-size: 16px;

        .van-field__body {
          width: 100%;
          height: 100%;
        }

        .van-field__control {
          width: 100%;
          height: 100%;
          text-indent: 20px;
        }
      }

      .icon-close {
        margin-right: 20px;
        display: block;
        width: 12px;
        height: 12px;
        cursor: pointer;
      }

      .code-btn {
        margin-right: 15px;
        font-size: 14px;
        font-weight: 400;
        color: #cccccc;
        cursor: pointer;

        &.active {
          color: #46d584;
        }

        /deep/ .van-count-down {
          line-height: 24px;
          color: #cccccc;
        }
      }
    }
  }

  .other {
    margin: 70px 0 20px 0;
    padding: 0 25px;
    font-size: 13px;
    font-weight: 400;
    color: #999999;

    .line {
      width: 110px;
      border-top: 1px solid #f4f4f4;
    }
  }

  .other-login {
    padding: 0 100px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;

    .other-img {
      margin-bottom: 6px;
      display: block;
      width: 50px;
      height: 50px;
    }
  }
}
</style>
